import initMenu from "./menu";
import { initCardsSlider } from "./sliders";
import initToggles from "./toggle";
import initFormActiveState from "./form-actives";
import initAnimateProgress from "./animate-progress";
import initHeaderObserver from "./project-header";

initToggles();

document.addEventListener("DOMContentLoaded", function () {
  initMenu();
  initCardsSlider();
  initFormActiveState();
  initAnimateProgress();
  initHeaderObserver();
});

function openMenu() {
  function init() {
    const trigger = document.querySelectorAll(".open-menu");
    const menu = document.querySelector(".mobile-menu");
    const body = document.body;

    trigger.forEach((el) => {
      el.addEventListener("click", () => {
        el.classList.toggle("is-active");
        menu.classList.toggle("is-open");
        body.classList.toggle("menu-open");
      });
    });
  }

  const isPresent = document.getElementsByClassName("open-menu");
  if (isPresent.length > 0) {
    init();
  }
}

openMenu();

function closeMenuOnContacts() {
  function init() {
    const contacts = document.querySelector(".mobile-contact-btn");
    const menu = document.querySelector(".mobile-menu");
    const menuTrigger = document.querySelector(".open-menu");
    const body = document.body;

    contacts.addEventListener("click", () => {
      menu.classList.remove("is-open");
      body.classList.remove("menu-open");
      menuTrigger.classList.remove("is-active");
    });
  }

  const isPresent = document.getElementsByClassName("mobile-contact-btn");
  if (isPresent.length > 0) {
    init();
  }
}

closeMenuOnContacts();

document.addEventListener("DOMContentLoaded", function () {
  var currentUrl = window.location.href;
  var langToggles = document.querySelectorAll(".lang-toggle"); // Use a class selector

  // Check if the current URL contains '/en/' to determine if English is active
  var isEstonian = currentUrl.includes("/et/");

  // Set the toggle state for all switchers based on the language
  langToggles.forEach(function (toggle) {
    toggle.checked = isEstonian;
  });

  // Add change event listener to each toggle
  langToggles.forEach(function (toggle) {
    toggle.addEventListener("change", function () {
      var siteUrl = window.location.origin;
      var newPath = window.location.pathname;

      var newUrl = "";

      if (this.checked) {
        // Switch to Estonian
        if (!isEstonian) {
          newUrl = siteUrl + "/et" + newPath;
        }
      } else {
        // Switch to Estonian
        if (isEstonian) {
          newUrl = siteUrl + newPath.replace("/et", "");
        }
      }

      // Redirect only if newUrl is set
      if (newUrl) {
        window.location.href = newUrl;
      }
    });
  });

  function addEvent(event, selector, callback, context) {
    document.addEventListener(event, (e) => {
      if (e.target.closest(selector)) {
        callback(e);
      }
    });
  }
  addEvent("click", ".cmplz-show-banner", function () {
    document.querySelectorAll(".cmplz-manage-consent").forEach((obj) => {
      obj.click();
    });
  });
});
